import React from "react";
import { MessageCircle } from "lucide-react";
import usePlatformWa, { buildWaLink } from "../lib/usePlatformWa";

/**
 * Floating "WhatsApp Support" button. Fixed bottom-right.
 * The number/message come from `/api/platform/whatsapp` (managed by admin
 * in /admin/settings) — no hardcoding. Per-instance overrides still allowed
 * via `number` / `message` props.
 */
export default function WhatsAppFloat({ number, message, label = "Chat on WhatsApp" }) {
  const platform = usePlatformWa();
  const num = number || platform.support_number;
  const text = message || platform.support_message;
  const href = buildWaLink(num, text);
  return (
    <a
      href={href}
      target="_blank"
      rel="nofollow noopener noreferrer"
      data-testid="wa-support-float"
      aria-label={label}
      className="fixed z-50 group"
      style={{
        bottom: "calc(env(safe-area-inset-bottom, 0px) + 1rem)",
        right: "calc(env(safe-area-inset-right, 0px) + 1rem)",
      }}
    >
      <span className="absolute right-16 top-1/2 -translate-y-1/2 hidden md:inline-block whitespace-nowrap rounded-md bg-slate-900 text-white text-xs font-semibold px-3 py-1.5 opacity-0 group-hover:opacity-100 transition shadow">
        {label}
      </span>
      <span className="block w-12 h-12 sm:w-14 sm:h-14 rounded-full bg-emerald-500 hover:bg-emerald-600 text-white shadow-xl shadow-emerald-500/30 ring-4 ring-emerald-500/15 transition active:scale-95 grid place-items-center">
        <MessageCircle className="w-5 h-5 sm:w-6 sm:h-6" fill="white" strokeWidth={1.5} />
      </span>
    </a>
  );
}
